var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "slide-first-wrapper" }, [
    _c("div", { staticClass: "side-menu-navigation" }, [
      _c("span", { staticClass: "links-header" }, [
        _vm._v(_vm._s(_vm.$t("sideMenu.platform")))
      ]),
      _c(
        "span",
        {
          staticClass: "link",
          on: {
            click: function($event) {
              return _vm.closeSideMenuWithRedirectTo(_vm.routes.home)
            }
          }
        },
        [_vm._m(0)]
      ),
      _c("span", { staticClass: "links-header" }, [
        _vm._v(_vm._s(_vm.$t("sideMenu.pages")))
      ]),
      _c(
        "span",
        {
          staticClass: "link",
          class: _vm.checkIsActivePage(_vm.routes.gopHome),
          on: {
            click: function($event) {
              return _vm.closeSideMenuWithRedirectTo(_vm.routes.gopHome)
            }
          }
        },
        [
          _c(
            "span",
            {
              staticClass: "hover-container create-story-button gop-container"
            },
            [
              _c("img", {
                attrs: {
                  src: require("@/common/assets/icons/home.svg"),
                  alt: "plus"
                }
              }),
              _c("span", [_vm._v(_vm._s(_vm.$t("sideMenu.home")))])
            ]
          )
        ]
      ),
      _c(
        "span",
        {
          staticClass: "link",
          class: _vm.checkIsActivePage(_vm.routes.gopSearch),
          on: {
            click: function($event) {
              return _vm.closeSideMenuWithRedirectTo(_vm.routes.gopSearch)
            }
          }
        },
        [
          _c(
            "span",
            {
              staticClass: "hover-container create-story-button gop-container"
            },
            [
              _c("img", {
                attrs: {
                  src: require("@/common/assets/icons/search.svg"),
                  alt: "plus"
                }
              }),
              _c("span", [_vm._v(_vm._s(_vm.$t("sideMenu.search")))])
            ]
          )
        ]
      ),
      (_vm.innerWidth > 600) & (_vm.innerHeight > 600) &&
      _vm.hasPermission(_vm.PERMISSIONS.additionalGopAccess)
        ? _c(
            "span",
            {
              staticClass: "link",
              class: _vm.checkIsActivePage(_vm.routes.createOffer),
              on: {
                click: function($event) {
                  return _vm.closeSideMenuWithRedirectTo(_vm.routes.createOffer)
                }
              }
            },
            [
              _c(
                "span",
                {
                  staticClass:
                    "hover-container create-story-button gop-container"
                },
                [
                  _c("img", {
                    attrs: {
                      src: require("@/common/assets/icons/plus.svg"),
                      alt: "plus"
                    }
                  }),
                  _c("span", [_vm._v(_vm._s(_vm.$t("sideMenu.createOffer")))])
                ]
              )
            ]
          )
        : _vm._e(),
      (_vm.innerWidth > 600) & (_vm.innerHeight > 600) &&
      _vm.hasPermission(_vm.PERMISSIONS.additionalGopAccess)
        ? _c(
            "span",
            {
              staticClass: "link",
              class: _vm.checkIsActivePage(_vm.routes.createSector),
              on: {
                click: function($event) {
                  return _vm.closeSideMenuWithRedirectTo(
                    _vm.routes.createSector
                  )
                }
              }
            },
            [
              _c(
                "span",
                {
                  staticClass:
                    "hover-container create-story-button gop-container"
                },
                [
                  _c("img", {
                    attrs: {
                      src: require("@/common/assets/icons/plus.svg"),
                      alt: "plus"
                    }
                  }),
                  _c("span", [_vm._v(_vm._s(_vm.$t("sideMenu.createSector")))])
                ]
              )
            ]
          )
        : _vm._e(),
      (_vm.innerWidth > 600) & (_vm.innerHeight > 600)
        ? _c(
            "span",
            {
              staticClass: "link",
              class: _vm.checkIsActivePage(_vm.routes.recognitions),
              on: {
                click: function($event) {
                  return _vm.closeSideMenuWithRedirectTo(
                    _vm.routes.recognitions
                  )
                }
              }
            },
            [
              _c(
                "span",
                {
                  staticClass:
                    "hover-container create-story-button gop-container"
                },
                [
                  _c("img", {
                    attrs: {
                      src: require("@/gop/assets/icons/cup.svg"),
                      alt: "plus"
                    }
                  }),
                  _c("span", [_vm._v(_vm._s(_vm.$t("sideMenu.recognitions")))])
                ]
              )
            ]
          )
        : _vm._e(),
      (_vm.innerWidth > 600) & (_vm.innerHeight > 600) &&
      _vm.hasPermission(_vm.PERMISSIONS.additionalGopAccess)
        ? _c(
            "span",
            {
              staticClass: "link",
              class: _vm.checkIsActivePage(_vm.routes.createRecognition),
              on: {
                click: function($event) {
                  return _vm.closeSideMenuWithRedirectTo(
                    _vm.routes.createRecognition
                  )
                }
              }
            },
            [
              _c(
                "span",
                {
                  staticClass:
                    "hover-container create-story-button gop-container"
                },
                [
                  _c("img", {
                    attrs: {
                      src: require("@/common/assets/icons/plus.svg"),
                      alt: "plus"
                    }
                  }),
                  _c("span", [
                    _vm._v(_vm._s(_vm.$t("sideMenu.createRecognition")))
                  ])
                ]
              )
            ]
          )
        : _vm._e(),
      _c(
        "span",
        {
          staticClass: "link",
          class: _vm.checkIsActivePage(_vm.routes.savedContent),
          on: {
            click: function($event) {
              return _vm.closeSideMenuWithRedirectTo(_vm.routes.savedContent)
            }
          }
        },
        [
          _c(
            "span",
            {
              staticClass: "hover-container create-story-button gop-container"
            },
            [
              _c("img", {
                attrs: {
                  src: require("@/common/assets/icons/saved-filled.svg"),
                  alt: "saved"
                }
              }),
              _c("span", [_vm._v(_vm._s(_vm.$t("sideMenu.savedContent")))])
            ]
          )
        ]
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "span",
      { staticClass: "hover-container create-story-button gop-container" },
      [
        _c("img", {
          attrs: {
            src: require("@/common/assets/icons/platform.svg"),
            alt: "platform"
          }
        }),
        _c("span", [_vm._v("DRC ")])
      ]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }